import router from './router'
import CustomerMessages from './localization'

export default {
  router,
  localization: CustomerMessages,
}
